import React from "react";
import { connect } from "react-redux";
import { Segment, Header, Button } from "semantic-ui-react";
import FormNuevaTarea from "./ventasNuevaTarea/FormNuevaTarea";
import TablaTareas from "./ventasNuevaTarea/TablaTareas";
import { ventasTareasOps } from "../../ducks/ventasTareas";

class VentasNuevaTarea extends React.Component {
  state = {
    visibleFormNuevo: false,
    editTarea: null
  };

  componentDidMount() {
    this.props.attachListenersTareasDeVenta(this.props.match.params.idColegio);
  }

  componentDidUpdate(prevProps) {
    if (this.props.dataSaved.status) {
      this.props.resetDataSaved();
    }
  }

  componentWillUnmount() {
    // this.props.quitarColegioSeleccionado();
    this.props.limpiarTareasDeVenta();
    this.props.detachListenersTareasDeVenta();
  }

  /*- Handle Methods-*/
  handleVolver = () => this.props.history.goBack();

  handleMostrarFormulario = () =>
    this.setState(state => ({ visibleFormNuevo: true }));

  handleDescartar = () => this.stateReset();

  handleAddTarea = values => {
    this.props.addNuevaTareaDeVenta({
      idColegio: this.props.match.params.idColegio,
      ...values,
      uid: this.props.user.uid,
      isEdit: this.state.editTarea !== null,
      completada: false
    });
    this.stateReset();
  };

  handleBorrarTarea = idTarea => this.props.borrarTareaDeVenta({ idTarea });

  handleEditTarea = idTarea =>
    this.setState(state => ({
      visibleFormNuevo: true,
      editTarea: this.props.tareasDeVenta.filter(({ id }) => id === idTarea)[0]
    }));

  handleCompletarTarea = idTarea =>
    this.props.completarTareaDeVenta({ idTarea });

  /*- Handle Helpers -*/
  stateReset = () =>
    this.setState(state => ({
      visibleFormNuevo: false,
      editTarea: null
    }));

  /*- Render & Render Helpers Methods -*/
  render() {
    const { colegioSeleccionado, tareasDeVenta } = this.props;
    return (
      <Segment>
        <Segment basic>
          <Button
            content="Cerrar"
            floated="right"
            color="pink"
            icon="cancel"
            onClick={this.handleVolver}
          />
          <Header
            as="h3"
            content={colegioSeleccionado && colegioSeleccionado.nombreColegio}
          />
        </Segment>

        <Segment basic>
          <Button
            content="Añadir Nueva Tarea"
            color="pink"
            icon="add"
            disabled={this.state.visibleFormNuevo}
            onClick={this.handleMostrarFormulario}
          />
          {this.state.visibleFormNuevo && (
            <Segment>
              <FormNuevaTarea
                handleAddTarea={this.handleAddTarea}
                handleDescartar={this.handleDescartar}
                initialValues={this.state.editTarea}
              />
            </Segment>
          )}
        </Segment>
        <Segment>
          <Header as="h3" content="Tareas" />
          <TablaTareas
            datos={tareasDeVenta}
            handleBorrarTarea={this.handleBorrarTarea}
            handleEditTarea={this.handleEditTarea}
            handleCompletarTarea={this.handleCompletarTarea}
          />
        </Segment>
      </Segment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.session.user,
  dataSaved: state.ventasTareas.dataSaved,
  colegioSeleccionado: state.ventas.colegioSeleccionado,
  tareasDeVenta: state.ventasTareas.tareasDeVenta
});

const mapDispatchToProps = {
  attachListenersTareasDeVenta: ventasTareasOps.attachListenersTareasDeVenta,
  detachListenersTareasDeVenta: ventasTareasOps.detachListenersTareasDeVenta,
  resetDataSaved: ventasTareasOps.resetDataSaved,
  limpiarTareasDeVenta: ventasTareasOps.limpiarTareasDeVenta,
  addNuevaTareaDeVenta: ventasTareasOps.addNuevaTareaDeVenta,
  borrarTareaDeVenta: ventasTareasOps.borrarTareaDeVenta,
  completarTareaDeVenta: ventasTareasOps.completarTareaDeVenta
};

export default connect(mapStateToProps, mapDispatchToProps)(VentasNuevaTarea);



// WEBPACK FOOTER //
// ./src/pages/ventas/VentasNuevaTarea.jsx